import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import petrovich from 'petrovich';
import { withTranslation } from 'react-i18next';

import { getIsParent } from 'app/selectors/user';
import ChildEvents from '../../components/Events/ChildEvents';
import { sendStatusAll } from '../../actions/events';
import unreadEventsCountById from '../../selectors/events/unread';


const mapStateToProps = (state, ownProps) => {
  const { params: { id }, t } = ownProps;
  const studentId = parseInt(id, 10);
  const student = state.students.data[studentId];
  const unread = (!state.user.parent && state.user.student)
    ? unreadEventsCountById(state).user
    : undefined;
  let header = '';

  if (id === 'user') {
    header = t('header_my_events');
  } else if (student) {
    const name = petrovich({ first: student.name.first, gender: student.sex }, 'genitive').first;
    header = `${t('header')} ${name}`;
  }

  return ({
    header,
    unread,
    isParent: getIsParent(state),
    userId: state.events.data.id,
  });
};

export default compose(
  withTranslation('events'),
  connect(mapStateToProps, dispatch => ({
    setAllRead: filter => dispatch(sendStatusAll({ read: true }, filter)),
  })),

  withState('notSticky', 'setNotSticky', true),

  withHandlers({
    handleAllViewed: props => (e) => {
      e.preventDefault();
      props.setAllRead(props.userId ? { student_id: props.userId } : {});
    },
  })

)(ChildEvents);
